import React, { Component, Fragment } from "react";
import Link from "gatsby-link";
import styled from "styled-components";
import Img from "gatsby-image";
import _ from "lodash";
import Flex, { FlexItem } from "styled-flex-component";
import Helmet from "react-helmet";
import { Title, CenteredFull } from "../components/Typography";
import { Heading, Card, Text, Strong, colors, Pill } from "evergreen-ui";

export default class BlogRoll extends Component {
	state = {
		years: []
	};

	addToYears = year => {
		this.setState(prevState => ({
			years: [...prevState.years, year]
		}));
	};

	render() {
		const posts = this.props.data.allMarkdownRemark.edges;

		return (
			<RollContainer>
				<Helmet title="Blog" />
				<CenteredFull>
					<Title>Narrow Road Home Blog</Title>
				</CenteredFull>
				<BlogGrid>
					{posts.map(post => {
						const year = post.node.frontmatter.date.match(/(\d{4})/g).pop();
						return (
							<Fragment>
								<Link to={post.node.fields.slug}>
									<Card border="extraMuted" key={post.node.id} hoverElevation={4}>
										<Flex>
											<BlogImage resolutions={post.node.frontmatter.featured_image.childImageSharp.resolutions} />
											<BlogFlex column>
												<Strong size={700}>
													{_.truncate(post.node.frontmatter.title, { length: 60, separator: " " })}
												</Strong>
												<BlogTags>
													{post.node.frontmatter.tags &&
														post.node.frontmatter.tags.map(tag => (
															<Link to={`/tags/${_.kebabCase(tag)}`}>
																<Pill style={{ display: "inline-block" }}>{tag}</Pill>
															</Link>
														))}
												</BlogTags>
												<Strong size={200} color={colors.green}>
													{post.node.frontmatter.date}
												</Strong>
												<Text>{post.node.excerpt}</Text>
											</BlogFlex>
										</Flex>
									</Card>
								</Link>
							</Fragment>
						);
					})}
				</BlogGrid>
			</RollContainer>
		);
	}
}

const RollContainer = styled.div`
	margin: 0 auto;
	margin-top: ${100 / 24}vw;
	max-width: 1400px;

	@media screen and (max-width: 1400px) {
		padding: 0 ${100 / 24}vw;
	}
`;

const BlogTags = styled.div`
	display: flex;
	grid-gap: 5px;
	grid-template-columns: repeat(auto-fill, 1fr);
	margin: 0.5rem 0;

	strong:not(:first-child) {
		margin-left: 5px;
	}
`;

const BlogGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, 500px);
	grid-gap: 35px 50px;
	justify-content: center;
	margin-bottom: 5rem;

	@media screen and (max-width: 500px) {
		grid-template-columns: repeat(auto-fit, calc(100vw / 24 * 22));
		grid-gap: 25px 0;
	}
`;

const BlogFlex = Flex.extend`
	padding: 10px 25px;
`;

const BlogImage = styled(Img)`
	margin-right: 15px;
	border-radius: 10px;

	@media screen and (max-width: 600px) {
		width: 80px !important;
		height: 80px !important;
		border-radius: 5px;
	}
`;

export const pageQuery = graphql`
	query AllBlogPosts {
		allMarkdownRemark(
			sort: { order: DESC, fields: [frontmatter___date] }
			filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
		) {
			edges {
				node {
					id
					excerpt(pruneLength: 40)
					timeToRead
					fields {
						slug
					}
					frontmatter {
						title
						tags
						date(formatString: "MMMM DD, YYYY")
						featured_image {
							childImageSharp {
								resolutions(width: 150, height: 150) {
									...GatsbyImageSharpResolutions_withWebp
								}
							}
						}
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/blog-roll.jsx